<template>
  <div id="app">
    <div class="header">
      <a href="https://www.omdbapi.com/"><img class="logo" src="./assets/ioet_logo.png" alt="logo"></a>
      <span class="description">QA app</span>
    </div>
    <div class="container">
      <div class="description2">This app is designed with <a target="_blank" href="https://www.ioet.com/">OMDb API</a> usage in purpose of QA skills evaluation.<br/>
      Below you can enter a movie details to get the information from OMDb. 
      </div>
      <Search v-on:SearchRequested="handleSearch"></Search>
      <Film v-bind:films="films"></Film>
      
    </div>
    <Footer class="footer" v-bind:footer="footer"></Footer>
  </div>
</template>

<script>

import Search from './components/search.vue'
import Film from './components/film.vue'
import Footer from './components/footer.vue'

export default {
  name: 'app',
  components:{Search , Film, Footer},
  data(){
    return{
          films:[]
     }
  },
  methods:{
    handleSearch(query){
      this.films=[];
     fetch('https://www.omdbapi.com/?t='+query+'&apikey=fe796a7e')
  .then((res) => { return res.json() } )
  .then((res) =>{ 
    this.films=res;
    console.log(this.films.Error)
  })
    }
    },
    created(){
        fetch('https://www.omdbapi.com/?t='+query+'&apikey=fe796a7e')
        .then((res) => { return res.json() } )
        .then((res) =>{ 
          this.films=res;
        console.log(this.films.Error)
        })
    }
  }

</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}
body {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.container {
  margin: 40px;
}
.header {
  /* background-color: #dfe6e9; */
  height: 70px;
  align-items: center;
  display: flex;
  /* background-color: antiquewhite; */
}
.logo {
  width: 160px;
  margin-left: 40px;
}
.description {
  padding-left: 30px;
  font-size: 20px;
  font-weight: 600;
  color: #555555;
}
.description2 {
  font-size: 15px;
  font-weight: 600;
  color: #555555;
  padding-bottom: 40px;
}
.footer {
  margin-top: 4em;
  background-color: #f1f2f6;
  height: 6em;
}
</style>



// WEBPACK FOOTER //
// src/App.vue